<template>
  <div class="location">
    <div class="row">
      <div class="col-12 col-lg-6">
        <select v-model="regionId" @change="regionChange">
          <option :value="null">Регион</option>
          <option v-for="loc in location" :key="loc.id" v-bind:value="loc.id">
            {{ loc.title }}
          </option>
        </select>
      </div>
      <div class="col-12 col-lg-6">
        <select
          v-model="cityId"
          :disabled="cities.length === 0"
          @change="cityChange"
        >
          <option :value="null">Город</option>
          <option v-for="city in cities" :key="city.id" v-bind:value="city.id">
            {{ city.title }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Search",
  props: {
    city: {
      default: null,
    },
    region: {
      default: null,
    },
  },
  data() {
    return {
      cities: [],
      regionId: null,
      cityId: null,
    };
  },
  created() {
    setTimeout(() => {
      this.regionId = this.region;
      this.cityId = this.city;

      console.log(this.location);
      // console.log('region',this.regionId);
      // console.log('city',this.cityId);
      if (this.regionId && this.regionId > 0) {
           for(let i=0;i<this.location.length;i++){
            if (this.location[i].id == this.regionId){
              this.cities = this.location[i].child;
            }
        }
      }
    }, 40);
  },
  methods: {
    regionChange(e) {
      this.regionId = e.target.value;
      if (this.regionId && this.regionId > 0) {
        for(let i=0;i<this.location.length;i++){
            if (this.location[i].id == this.regionId){
              this.cities = this.location[i].child;
            }
        }

      } else {
        this.cities = [];
        this.$emit("input", null);
      }
    },
    cityChange(e) {
      this.cityId = e.target.value;
      if (this.cityId && this.cityId > 0) {
        this.$emit("input", this.cityId);
      } else {
        this.$emit("input", null);
      }
    },
  },
  computed: {
    ...mapState(["location"]),
  },
};
</script>
<style lang="scss">
.location {
  select {
    padding: 5px 5px;
    width: 100%;
    height: 34px;
    border-radius: 10px;
    margin-bottom: 15px;
  }
}
</style>
